<template>
  <div class="section">
    <div class="header">
      <span>回款总览</span>
    </div>
    <div class="main">
      <div class="left">
        <div class="item">
          <img class="icon" src="@/assets/img/operate/xmys.png" />
          <div class="content">
            <span class="label">待回款额（万元）</span>
            <div class="value">
              <span class="val">{{ formatNumber(details.waitBackAmount) }}</span>
            </div>
            <span class="label">已回款额（万元）</span>
            <div class="value">
              <span class="val">{{ formatNumber(details.actualBackAmount) }}</span>
            </div>
          </div>
        </div>
        <div class="item2">
          <div class="line1">
            <img class="icon" src="@/assets/img/operate/tb.png" />
            <span class="label">实际回款率</span>
          </div>
          <div class="chart-content" id="chart9"></div>
        </div>
      </div>
      <div class="right">
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">月度计划与实际回款对比分析</span>
          </div>
          <div class="chart-content" id="chart10"></div>
        </div>
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">项目回款额排行</span>
            <el-select v-model="chart11Value" @change="chart11Change">
              <el-option label="按回款额" value="1"></el-option>
              <el-option label="按回款率" value="2"></el-option>
            </el-select>
          </div>
          <div class="chart-content" id="chart11"></div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible1" title="项目回款">
      <el-form inline>
        <el-form-item>
          {{ currentName }}
        </el-form-item>
      </el-form>
      <el-table :data="tableData1">
        <el-table-column prop="ym" label="月份" />
        <el-table-column prop="actualBackAmount" label="实际回款（元）" />
        <el-table-column prop="planBackAmount" label="计划回款（元）" />
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" title="月度实际与计划回款对比">
      <el-form inline>
        <el-form-item>
          {{ currentName }}
        </el-form-item>
      </el-form>
      <el-table :data="tableData2">
        <el-table-column prop="projectName" label="项目名称" />
        <el-table-column prop="actualBackAmount" label="实际回款（元）" />
        <el-table-column prop="planBackAmount" label="计划回款（元）" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
export default {
  name: 'Overview4',
  mixins: [chartMixin],
  data() {
    return {
      currentName: '',
      dialogVisible1: false,
      dialogVisible2: false,
      tableData1: [],
      tableData2: [],
      searchForm: {
        startTime: '', // 开始日期
        endTime: '' // 结束日期
      },
      chart11Value: '1',
      details: {
        actualBackPer: '', // 实际回款率
        ymList: [], // 年月列表
        actualBackAmountMonthList: [], // 按月-实际回款金额列表
        planBackAmountMonthList: [], // 按月-计划回款金额列表
        amountProjectNameList: [], // 按回款金额-项目列表
        actualBackAmountProjectList: [], // 按回款金额-实际回款金额列表
        planBackAmountProjectList: [], // 按回款金额-计划回款金额列表
        perProjectNameList: [], // 按回款率-项目列表
        actualBackPerProjectList: [], // 按回款率-实际回款率列表
        actualBackAmount: '', // 实际回款金额【年经营数据】
        waitBackAmount: '' // 待回款金额【开累经营数据】
      }
    }
  },
  created() {
    this.$event.$on('yearMonthChange', this.loadData)
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  beforeDestroy() {
    this.$event.$off('yearMonthChange')
  },
  watch: {
  },
  methods: {
    formatNumber(num) {
      // 检查输入是否为数字
      if (!num) {
        return '--'
      }
      // 除以 10000 并保留三位小数
      const result = (num / 10000).toFixed(3);
      // 返回结果（注意：toFixed 返回的是字符串，如果需要数字可以转换）
      return parseFloat(result);
    },
    loadData(searchForm) {
      this.searchForm = searchForm
      this.$axios.get(this.$apis.operate.selectBack, searchForm).then(res => {
        this.details = res || {}
        this.initChart9()
        this.initChart10()
        this.initChart11()
      })
    },
    initChart9() {
      const chart = this.$getChartInstance('#chart9')
      if (!chart) return;
      const option = {
        title: {
        },
        series: [
          {
            type: 'liquidFill',
            data: [this.details.actualBackPer / 100],
            radius: '70%',
            color: [new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 1, color: '#39E179' }, // 起始颜色
              { offset: 0, color: '#9DD6BD' } // 结束颜色
            ])],
            label: {
              normal: {
                textStyle: {
                  color: '#293441', // 文字颜色
                  fontSize: 16     // 文字字号
                }
              }
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 0
              }
            }
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
    },
    initChart10() {
      const chart = this.$getChartInstance('#chart10')
      if (!chart) return;
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.details.ymList,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#346EB1',
            },
            data: this.details.planBackAmountMonthList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#39E179' }, // 起始颜色
                { offset: 0, color: '#9DD6BD' } // 结束颜色
              ]),
            },
            data: this.details.actualBackAmountMonthList
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
          const yearMonth = this.details.ymList[index]
          this.currentName = yearMonth
          this.selectBackMonthVs(yearMonth)
          this.dialogVisible2 = true
        }
      })
    },
    initChart11() {
      const chart = this.$getChartInstance('#chart11')
      if (!chart) return;
      let series = []
      let yAxisData = []
      if (this.chart11Value === '1') {
        yAxisData = this.details.amountProjectNameList
        series.push({
          name: '计划',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#346EB1',
          },
          data: this.details.planBackAmountProjectList
        }, {
          name: '实际',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#1AD1B0',
          },
          data: this.details.actualBackAmountProjectList
        })
      } else {
        yAxisData = this.details.perProjectNameList
        series.push({
          name: '回款率',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#2297F0',
          },
          data: this.details.actualBackPerProjectList
        })
      }
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            if (this.chart11Value === '2') {
              let tooltipStr = params[0].name + '<br>';
              for (let i = 0; i < params.length; i++) {
                // 显示系列名称、图例颜色和数据信息
                tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '%<br>';
              }
              return tooltipStr;
            } else {
              let tooltipStr = params[0].name + '<br>';
              for (let i = 0; i < params.length; i++) {
                // 显示系列名称、图例颜色和数据信息
                tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
              }
              return tooltipStr;
            }
          }
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            fontSize: 16,
            color: '#7F8FA4',
            formatter: function (value, index) {
              return value.length > 5 ? value.substring(0, 5) + '...' : value;
            }
          },
          data: yAxisData
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: series
      }
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1]
          const projectName = yAxisData[index]
          this.currentName = projectName
          this.selectBackProjectVs(projectName)
          this.dialogVisible1 = true
        }
      })
    },
    chart11Change() {
      this.initChart11()
    },
    selectBackMonthVs(yearMonth) {
      this.$axios.get(this.$apis.operate.selectBackMonthVs, {
        yearMonth
      }).then(res => {
        this.tableData2 = res || []
      })
    },
    selectBackProjectVs(projectName) {
      const item = this.projectList.find(item => item.projectName === projectName)
      this.$axios.get(this.$apis.operate.selectBackProjectVs, {
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        projectId: item.projectId
      }).then(res => {
        this.tableData1 = res || []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section {
  height: 570px;
  background: #FFFFFF;
  border-radius: 2px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  &.total {
    height: 392px;
    margin-top: 50px;
  }

  .header {
    height: 60px;
    border-bottom: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
    padding: 0 24px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .main {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 60px;

    .left {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          .value {
            display: flex;
            align-items: flex-end;
            align-items: center;
            margin-top: 16px;
            margin-bottom: 16px;

            span {
              &.yuan {
                font-size: 20px;
                margin-right: 10px;
                line-height: 32px;
              }

              &.val {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #354052;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }

          .desc {
            display: flex;
            align-items: center;
            margin-top: 20px;

            span {
              &:nth-child(1) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #7F8FA4;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }

              &:nth-child(2) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #354052;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-left: 10px;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }
        }
      }

      .item2 {
        display: flex;
        flex-direction: column;
        height: 250px;

        .line1 {
          display: flex;
          align-items: center;

          img {
            margin-right: 16px;
          }

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .chart-content {
          width: 250px;
          height: 250px;
          margin-top: 10px;
        }
      }
    }

    .right {
      flex: 1;
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 90px;

      .chart-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-top: 49px;

        &:nth-child(n + 2) {
          margin-left: 60px;
        }

        .chart-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .chart-content {
          flex: 1;
          padding-top: 40px;
        }
      }
    }
  }
}
</style>
